var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment__instrument transaction-container payments_form" },
    [
      !_vm.showSightlineImg
        ? _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Transaction.Sightline")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showSightlineImg
        ? _c("img", {
            staticClass: "PlayPlusImg",
            attrs: {
              src: _vm.mediaServer(
                "/static/brand-img/" + _vm.brandKey + "/sightline.png"
              ),
              alt: "Sightline"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isProcessing && !_vm.isProcessingEnrollment
        ? _c("div", { staticClass: "processing-wrapper" }, [
            _c(
              "span",
              { staticClass: "pw" },
              [
                _c("v-progress-circular", {
                  staticClass: "redirecting-circular-progress",
                  attrs: { indeterminate: "" }
                }),
                _vm._v("\n      " + _vm._s(_vm.processingMessage) + "\n    ")
              ],
              1
            )
          ])
        : _c("div", [
            _c("div", [
              _vm.sightlineNote
                ? _c("div", {
                    staticClass: "note",
                    domProps: { innerHTML: _vm._s(_vm.sightlineNote) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isInstructionVerified
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.depositType
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "transaction deposit-sightline",
                              attrs: {
                                color: "success",
                                disabled: !_vm.customerCanDeposit
                              },
                              on: { click: _vm.depositSightline }
                            },
                            [_vm._v(_vm._s(_vm.$t("Transaction.Deposit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.withdrawType
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "transaction withdrawal-sightline",
                              attrs: {
                                color: "success",
                                disabled: !_vm.customerCanWithdraw
                              },
                              on: { click: _vm.withdrawalSightline }
                            },
                            [_vm._v(_vm._s(_vm.$t("Transaction.Withdrawal")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "transaction funding-sightline",
                          attrs: {
                            color: "success",
                            disabled: !_vm.userIsVerifed
                          },
                          on: { click: _vm.fundingSightline }
                        },
                        [_vm._v(_vm._s(_vm.$t("Transaction.Funding")))]
                      )
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "transaction",
                            attrs: {
                              color: "success",
                              disabled: _vm.isProcessing || !_vm.userIsVerifed
                            },
                            on: { click: _vm.startEnrollFlow }
                          },
                          [_vm._v(_vm._s(_vm.$t("Transaction.Enroll")))]
                        )
                      ],
                      1
                    )
                  ])
            ])
          ]),
      _vm._v(" "),
      _c(
        "v-form",
        {
          attrs: {
            id: "spanexpress",
            name: "LaunchSpanExpress",
            action: _vm.postUrl,
            method: "post"
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.postUrl) + "\n      "),
          _c("input", {
            attrs: { name: "MerchantID", id: "MerchantID" },
            domProps: { value: _vm.merchantID }
          }),
          _vm._v(" "),
          _c(
            "textarea",
            { attrs: { name: "IdentityToken", id: "IdentityToken" } },
            [_vm._v(_vm._s(_vm.identityToken))]
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "MemberNumber", id: "MemberNumber" },
            domProps: { value: _vm.memberNumber }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "FirstName", id: "FirstName" },
            domProps: { value: _vm.firstName }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "LastName", id: "LastName" },
            domProps: { value: _vm.lastName }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "PhoneNumber", id: "PhoneNumber" },
            domProps: { value: _vm.phoneNumber }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "Email", id: "Email" },
            domProps: { value: _vm.eMail }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "Address", id: "Address" },
            domProps: { value: _vm.address }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "City", id: "City" },
            domProps: { value: _vm.city }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "State", id: "State" },
            domProps: { value: _vm.state }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "Country", id: "Country" },
            domProps: { value: _vm.country }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "PostalCode", id: "PostalCode" },
            domProps: { value: _vm.postalCode }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "MerchantApplication", id: "MerchantApplication" },
            domProps: { value: _vm.merchantApplication }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              name: "MerchantTransactionID",
              id: "MerchantTransactionID"
            },
            domProps: { value: _vm.merchantTransactionID }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "ReturnUrl", id: "ReturnUrl" },
            domProps: { value: _vm.returnURL }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "MerchantName", id: "MerchantName" },
            domProps: { value: _vm.merchantName }
          }),
          _vm._v(" "),
          _c("input", { attrs: { type: "submit" } })
        ]
      ),
      _vm._v(" "),
      _vm.brandKey === "circa" && _vm.isSightlineAvailable
        ? _c("div", [_vm._v(_vm._s(_vm.$t("Transaction.Circa.PlayPlus.Note")))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "go-back",
          on: {
            click: function($event) {
              return _vm.goToHomepage()
            }
          }
        },
        [
          _c("v-icon", [_vm._v("navigate_before")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.back))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessingEnrollment,
            isTitleVisible: !!_vm.processingEnrollmentDialogError,
            isSuccess: !_vm.processingEnrollmentDialogError,
            errorText: _vm.processingEnrollmentDialogError,
            processingText: _vm.$t(
              "Transaction.Sightline.Enroll.Redirection.Dialog.Text"
            )
          },
          model: {
            value: _vm.processingEnrollmentDialog,
            callback: function($$v) {
              _vm.processingEnrollmentDialog = $$v
            },
            expression: "processingEnrollmentDialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _c("p", [_vm._v(_vm._s(_vm.processingEnrollmentDialogError))]),
            _vm._v(" "),
            _vm.brandKey === "sb"
              ? _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.customerServiceMessage) }
                })
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22a8891f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a8891f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Sightline.vue
// module id = null
// module chunks = 